export var DirectionType;
(function (DirectionType) {
    DirectionType["Horizontal"] = "horizontal";
    DirectionType["Vertical"] = "vertical";
    DirectionType["Cardinal"] = "cardinal";
})(DirectionType || (DirectionType = {}));
export var HorizontalDirection;
(function (HorizontalDirection) {
    HorizontalDirection["Left"] = "Left";
    HorizontalDirection["Right"] = "Right";
})(HorizontalDirection || (HorizontalDirection = {}));
export var VerticalDirection;
(function (VerticalDirection) {
    VerticalDirection["Top"] = "Top";
    VerticalDirection["Bottom"] = "Bottom";
})(VerticalDirection || (VerticalDirection = {}));
//# sourceMappingURL=direction-control.types.js.map